module.exports = __webpack_public_path__ + "static/media/s_20.d8ad96a7.mp3";